interface FilterChipProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

export function FilterChip({ label, active, onClick }: FilterChipProps) {
  return (
    <button
      onClick={onClick}
      className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all whitespace-nowrap ${
        active
          ? 'bg-[#523EF7] text-white shadow-md'
          : 'border border-[#DDDDDD] text-[#3F3F3F] hover:border-[#BBBBBB] hover:bg-[#F2F2F2]'
      }`}
    >
      {label}
    </button>
  );
}
